import React from 'react';
import NotificationBadge from '../NotificationBadge/NotificationBadge';
import './Tabs.css';

/**
 * Shared segmented tab control - replaces the hand-rolled tab bars that
 * were copy-pasted across Search, Binders, Profile, and Requests.
 *
 * items: [{ id, label, shortLabel?, badge? }]
 *   - shortLabel shows on narrow screens (falls back to label)
 *   - badge > 0 renders a NotificationBadge on the tab
 * variant:
 *   - 'primary'   segmented pill track (top-level sections)
 *   - 'secondary' small ghost pills (filters within a section)
 */
function Tabs({ items, active, onChange, variant = 'primary', className = '' }) {
    return (
        <div className={`ts-tabs ts-tabs-${variant} ${className}`} role="tablist">
            {items.map(item => (
                <button
                    key={item.id}
                    type="button"
                    role="tab"
                    aria-selected={active === item.id}
                    className={`ts-tab${active === item.id ? ' active' : ''}`}
                    onClick={() => onChange(item.id)}
                >
                    <span className="ts-tab-full">{item.label}</span>
                    <span className="ts-tab-abbr">{item.shortLabel || item.label}</span>
                    {item.badge > 0 && <NotificationBadge count={item.badge} size="small" />}
                </button>
            ))}
        </div>
    );
}

export default Tabs;
